import { useCallback } from 'react'
import { getReturnConcepts } from '../../redux/thunks'
import {
  TbDashDetailedItem,
  TbDashDetailedItemRow
} from 'tinybots-react-components/lib/components/DashboardComponents'
import React from 'react'
import { ButtonBase, styled } from '@material-ui/core'
import { useDispatch } from 'react-redux'

export const StatusButton = styled(ButtonBase)({
  display: 'inline-block',
  padding: '8px 22px',
  textAlign: 'center',
  verticalAlign: 'middle',
  background: '#8356ac',
  height: 36,
  minWidth: 80,
  outline: 'none',
  MozAppearance: 'none',
  fontFamily: 'Montserrat!important',
  fontSize: 16,
  lineHeight: 1,
  boxSizing: 'border-box',
  borderRadius: 5,
  marginTop: 8,
  color: 'white',
  marginLeft: 53
})

export const ConceptReturnsSearch = ({
  clientId,
  setClientId,
  robotSerial,
  setRobotSerial,
  uuid,
  setUuid
}: {
  clientId: string
  setClientId: React.Dispatch<React.SetStateAction<string>>
  robotSerial: string
  setRobotSerial: React.Dispatch<React.SetStateAction<string>>
  uuid: string
  setUuid: React.Dispatch<React.SetStateAction<string>>
}) => {
  const dispatch = useDispatch()
  const onChangeClientId = useCallback(
    (value: string) => {
      setClientId(value)
    },
    [setClientId]
  )
  const onChangeUuid = useCallback(
    (value: string) => {
      setUuid(value)
    },
    [setUuid]
  )
  const onChangeSerial = useCallback(
    (value: string) => {
      setRobotSerial(value)
    },
    [setRobotSerial]
  )
  const onSearch = useCallback(() => {
    if (clientId.length + uuid.length + robotSerial.length > 0) {
      dispatch(
        getReturnConcepts({
          uuid,
          clientId,
          robotSerial
        })
      )
    }
  }, [dispatch, clientId, uuid, robotSerial])

  return (
    <>
      <TbDashDetailedItemRow>
        <TbDashDetailedItem
          type='text'
          label='Client id'
          iconUrl=''
          value={clientId}
          onChange={onChangeClientId}
        />
        <TbDashDetailedItem
          type='text'
          label='Tessa serial'
          iconUrl=''
          value={robotSerial}
          onChange={onChangeSerial}
        />
      </TbDashDetailedItemRow>
      <TbDashDetailedItemRow>
        <TbDashDetailedItem
          type='text'
          label='Universally unique id (UUID)'
          iconUrl=''
          value={uuid}
          onChange={onChangeUuid}
        />
      </TbDashDetailedItemRow>
      <TbDashDetailedItemRow>
        <StatusButton onClick={onSearch}>SEARCH CONCEPTS</StatusButton>
      </TbDashDetailedItemRow>
      <div style={{ marginTop: 130 }}></div>
    </>
  )
}
